import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance3f3szy9qmf19h as Data_getInstance } from './adapter/DeletePinMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePinMutation_VariablesAdapter_instance3oybljjiooupn as DeletePinMutation_VariablesAdapter_instance } from './adapter/DeletePinMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePin) {
        this.g6g_1 = deletePin;
      }
      toString() {
        return 'Data(deletePin=' + this.g6g_1 + ')';
      }
      hashCode() {
        return this.g6g_1 == null ? 0 : getBooleanHashCode(this.g6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.g6g_1 == other.g6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.h6g_1 = '4959d3041a099d0c81ec21b955af64a4289b42092bf6de72160613a29419fd95';
        this.i6g_1 = 'deletePin';
      }
      r6f() {
        return 'mutation deletePin($input: DeletePinInput!) { deletePin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeletePinMutationClass;
function DeletePinMutation() {
  if (DeletePinMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.j6g_1 = input;
      }
      t6f() {
        return '4959d3041a099d0c81ec21b955af64a4289b42092bf6de72160613a29419fd95';
      }
      operationId() {
        return this.t6f();
      }
      l48() {
        return Companion_instance.r6f();
      }
      u6f() {
        return 'deletePin';
      }
      operationName() {
        return this.u6f();
      }
      f47(writer, customScalarAdapters, withDefaultValues) {
        DeletePinMutation_VariablesAdapter_instance.k6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      e47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeletePinMutation(input=' + this.j6g_1.toString() + ')';
      }
      hashCode() {
        return this.j6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePinMutation()))
          return false;
        if (!this.j6g_1.equals(other.j6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePinMutation', VOID, VOID, [Mutation()]);
    DeletePinMutationClass = $;
  }
  return DeletePinMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1jasy19j4j968,
  DeletePinMutation as DeletePinMutation2z9xaiydj80c8,
};
//endregion

//# sourceMappingURL=DeletePinMutation.mjs.map
